import createReactComponent from '../createReactComponent';
export default createReactComponent('pills', 'IconPills', [
  ['path', { d: 'M8 8m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0', key: 'svg-0' }],
  ['path', { d: 'M17 17m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0', key: 'svg-1' }],
  ['path', { d: 'M4.5 4.5l7 7', key: 'svg-2' }],
  ['path', { d: 'M19.5 14.5l-5 5', key: 'svg-3' }],
]);
